import { FC, PropsWithChildren, useEffect } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { NOTIFICATION_SHOW_TIME } from 'modules/shop/notificationManager/constants';
import styles from './styles.module.css';

export const Notification: FC<PropsWithChildren & { onClose?: () => void }> = ({
  children,
  onClose,
}) => {
  useEffect(() => {
    const t = setTimeout(() => {
      onClose?.();
    }, NOTIFICATION_SHOW_TIME);

    return () => {
      clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.notification}>
      <div className={styles.content}>{children}</div>
      {onClose && (
        <Icon
          type={IconType.close}
          className={styles.closeButton}
          onClick={onClose}
        />
      )}
    </div>
  );
};
